import type {ReactElement} from 'react';
import React from 'react';
import {BottomBarItemColorFill} from '@Components/poster-editor/components/poster-editor-bottom-bar/components/bottom-bar-item-color-fill';
import {useGetKeyOfFillFromTextStylesOfSelectedTextSlideItem} from '@Hooks/poster-editor/useGetKeyOfFillFromTextStylesOfSelectedTextSlideItem';

export function SlideItemColorFill(): ReactElement<any> | null {
  const fillType = useGetKeyOfFillFromTextStylesOfSelectedTextSlideItem('fillType');
  const fillColor = useGetKeyOfFillFromTextStylesOfSelectedTextSlideItem('fillColor');

  if (!fillColor || fillType === undefined) {
    return null;
  }

  return <BottomBarItemColorFill type={fillType} color={fillColor} />;
}
